const ButtonLink = (props) => {
  const { text, extraClasses, cancel, disabled, shadowless, ...otherProps } = props;

  return (
    <a
      className={`${
        cancel ? 'border border-gray-300 bg-white' : 'background-theme text-theme'
      } block text-center rounded p-2 shadow-lg uppercase ${
        disabled ? 'opacity-50' : ''
      } ${extraClasses}`}
      disabled={disabled}
      {...otherProps}
    >
      {text}
    </a>
  );
};

export default ButtonLink;
